export default __webpack_public_path__ + "static/media/atn.93098860.png";